import React from 'react';
import { meterGeometry } from '../../../scouting/reviewModel';
import type { Flag } from '../../../scouting/recording';

export const ReviewMeter: React.FC<{ value: number; threshold: number; flag: Flag }> = ({ value, threshold, flag }) => {
  const { fillPct, markLeftPct } = meterGeometry(value, threshold);
  return (
    <div className="rev-meter" data-testid="review-meter">
      <div className="rev-meter__track">
        <div className="rev-meter__mark" style={{ left: `${markLeftPct}%` }} />
        <div className={`rev-meter__fill rev-meter__fill--${flag}`} style={{ width: `${fillPct}%` }} />
      </div>
    </div>
  );
};

export default ReviewMeter;
